// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Order Details Page Styles - Minimalist Theme */
.order-details-page {
  padding: 1.5rem;
  max-width: 1200px;
  margin: 0 auto;
  min-height: calc(100vh - 80px);
  background: var(--bg-primary);
  color: var(--text-primary);
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

.order-details-header {
  margin-bottom: 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 1rem;
}

.back-link {
  display: inline-flex;
  align-items: center;
  color: var(--text-secondary);
  text-decoration: none;
  font-weight: 500;
  margin-bottom: 1rem;
  padding: 8px 16px;
  border-radius: 8px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  background: var(--bg-secondary);
  box-shadow: var(--shadow-sm);
  border: 1px solid var(--border-color);
  font-size: 0.9375rem;
}

.back-link:hover {
  background: var(--nav-hover-bg);
  color: var(--text-primary);
  border-color: var(--accent-primary);
}

.order-details-title {
  font-size: 2rem;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0;
  letter-spacing: -0.015em;
}

/* Order Details Container */
.order-details-container {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.order-hero-card {
  background: var(--bg-secondary);
  border: 1px solid var(--border-color);
  border-radius: 16px;
  padding: 2rem;
  box-shadow: var(--shadow-md);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.order-hero-card:hover {
  border-color: var(--accent-primary);
}

.order-hero-top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  flex-wrap: wrap;
}

.order-id-block {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}

.eyebrow {
  text-transform: uppercase;
  letter-spacing: 0.05em;
  font-size: 0.75rem;
  color: var(--text-secondary);
  margin: 0;
  font-weight: 700;
}

.order-number {
  font-size: 1.75rem;
  color: var(--text-primary);
  margin: 0;
  font-family: 'SF Mono', 'Courier New', Courier, monospace;
}

.order-id-hint {
  margin: 0;
  color: var(--text-secondary);
  font-size: 0.875rem;
}

.order-status-block {
  display: flex;
  align-items: flex-end;
  gap: 0.5rem;
  position: relative;
}

.status-badge-wrapper {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
}

.status-edit-btn {
  background: var(--bg-primary);
  border: 1px solid var(--border-color);
  border-radius: 8px;
  padding: 8px;
  cursor: pointer;
  color: var(--text-secondary);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.status-edit-btn:hover {
  background: var(--nav-hover-bg);
  color: var(--text-primary);
  border-color: var(--accent-primary);
  transform: translateY(-1px);
}

.order-meta-grid {
  margin-top: 1.5rem;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 1rem;
}

.meta-card {
  background: var(--bg-primary);
  border: 1px solid var(--border-color);
  border-radius: 12px;
  padding: 1rem;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.meta-card:hover {
  border-color: var(--accent-primary);
  box-shadow: var(--shadow-sm);
  transform: translateY(-2px);
}

.meta-label {
  display: block;
  color: var(--text-secondary);
  font-size: 0.8125rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.meta-value {
  color: var(--text-primary);
  font-size: 1rem;
  font-weight: 700;
}

/* Card Styles - убраны блоки, обычный формат */
.order-main-info,
.order-client,
.order-additional-info,
.order-timeline,
.order-address,
.order-companies {
  background: transparent;
  border-radius: 0;
  padding: 0;
  box-shadow: none;
  border: none;
  margin-bottom: 2rem;
}

.photo-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 0.85rem;
}

.photo-thumb {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  background: var(--bg-primary);
  border: 1px solid var(--border-color);
  border-radius: 12px;
  padding: 0.75rem;
  box-shadow: var(--shadow-sm);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  text-decoration: none;
  color: var(--text-primary);
}

.photo-thumb:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-md);
  border-color: var(--accent-primary);
}

.photo-thumb img {
  width: 100%;
  height: 160px;
  object-fit: cover;
  border-radius: 8px;
  border: 1px solid var(--border-color);
  background: var(--nav-hover-bg);
}

.photo-name {
  font-size: 0.9rem;
  font-weight: 600;
  color: var(--text-primary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.order-photos {
  margin-bottom: 2rem;
}

/* Order ID Section */
.order-id-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
  padding-bottom: 1rem;
  border-bottom: 2px solid var(--border-color);
}

.order-id-section h2 {
  font-size: 1.75rem;
  color: var(--text-primary);
  margin: 0;
  font-weight: 700;
}

/* Section Titles */
.section-title {
  font-size: 1.5rem;
  color: var(--text-primary);
  margin: 0 0 1.25rem 0;
  padding-bottom: 0.75rem;
  border-bottom: 2px solid var(--border-color);
  font-weight: 700;
  letter-spacing: -0.015em;
}

.order-photos .section-title {
  margin-bottom: 0.5rem;
}

.order-photos .section-subtitle {
  margin-top: -0.35rem;
  margin-bottom: 0.85rem;
}

.subsection-title {
  font-size: 1.125rem;
  color: var(--text-primary);
  margin: 0 0 0.75rem 0;
  font-weight: 600;
}

/* Status badge styles moved to status-badge.css */

.status-badge-button {
  background: transparent;
  border: none;
  padding: 0;
  cursor: pointer;
}

.status-popup {
  position: absolute;
  top: 112%;
  right: 0;
  width: 250px;
  background: var(--bg-primary);
  border: 1px solid var(--border-color);
  border-radius: 12px;
  box-shadow: var(--shadow-sm);
  padding: 12px 12px 10px;
  z-index: 50;
  transform-origin: top right;
  animation: statusPopupPop 0.2s ease-out both;
}

.status-popup-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 800;
  color: var(--text-primary);
  margin-bottom: 10px;
}

.status-popup-close {
  background: transparent;
  border: none;
  font-size: 1.15rem;
  line-height: 1;
  cursor: pointer;
  color: var(--text-secondary);
  transition: color 0.2s ease;
  width: 28px;
  height: 28px;
  border-radius: 8px;
}

.status-popup-close:hover {
  color: var(--text-primary);
  background: var(--nav-hover-bg);
}

.status-popup-body select {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid var(--border-color);
  border-radius: 10px;
  background: var(--bg-secondary);
  color: var(--text-primary);
  font-weight: 600;
  outline: none;
  transition: border-color 0.2s ease;
}

.status-popup-body select:focus {
  border-color: var(--accent-primary);
}

.status-popup-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 12px;
}

.status-popup .btn.btn-primary {
  padding: 10px 14px;
  border-radius: 10px;
  background: var(--accent-primary);
  color: #fff;
  border: 1px solid transparent;
  font-weight: 700;
  transition: all 0.2s ease;
}

.status-popup .btn.btn-primary:not(:disabled):hover {
  background: var(--accent-hover);
}

.status-popup .btn.btn-secondary {
  padding: 10px 14px;
  border-radius: 10px;
  border: 1px solid var(--border-color);
  background: transparent;
  color: var(--text-primary);
  font-weight: 700;
  transition: all 0.2s ease;
}

.status-popup .btn.btn-secondary:hover {
  background: var(--nav-hover-bg);
}

@keyframes statusPopupPop {
  from {
    opacity: 0;
    transform: translateY(-6px) scale(0.98);
  }

  60% {
    opacity: 1;
    transform: translateY(0) scale(1.02);
  }

  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.status-badge.pending {
  background: #fef3c7;
  color: #92400e;
  border-color: #fcd34d;
}

.status-badge.in-progress {
  background: #dbeafe;
  color: #1e40af;
  border-color: #93c5fd;
}

.status-badge.in-work {
  background: #fef3c7;
  color: #92400e;
  border-color: #fcd34d;
}

.status-badge.done {
  background: #d1fae5;
  color: #065f46;
  border-color: #6ee7b7;
}

.status-badge.canceled {
  background: #fee2e2;
  color: #991b1b;
  border-color: #fca5a5;
}

.status-badge.completed {
  background: #d1fae5;
  color: #065f46;
  border-color: #6ee7b7;
}

.status-badge.cancelled {
  background: #fee2e2;
  color: #991b1b;
  border-color: #fca5a5;
}

.status-badge.unknown {
  background: var(--bg-primary);
  color: var(--text-primary);
  border-color: #d1d5db;
}

/* Info Grids */
.info-grid,
.timeline-grid,
.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1rem;
}

.info-item,
.timeline-item,
.stat-item {
  display: flex;
  flex-direction: row;
  align-items: baseline;
  padding: 12px;
  background: var(--bg-primary);
  border-radius: 8px;
  border-left: 3px solid var(--accent-color);
  border: 1px solid var(--border-color);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.timeline-item {
  border-left-color: #8b5cf6;
}

.info-item:hover,
.timeline-item:hover,
.stat-item:hover {
  background: var(--nav-hover-bg);
  border-color: var(--accent-primary);
  transform: translateY(-1px);
}

.info-item label,
.timeline-item label,
.stat-item label {
  font-size: 0.8125rem;
  font-weight: 600;
  color: var(--text-secondary);
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-bottom: 0;
  margin-right: 0.75rem;
  min-width: 140px;
  flex-shrink: 0;
}

.info-item span,
.timeline-item span,
.stat-item span {
  font-size: 0.9375rem;
  color: var(--text-primary);
  font-weight: 500;
  word-break: break-word;
  line-height: 1.5;
  flex: 1 1;
}

.price-value {
  font-size: 1.125rem;
  font-weight: 600;
  color: #10b981;
}

/* Client Info Styles */
.order-client {
  background: var(--bg-primary);
  border-radius: 16px;
  padding: 1.5rem;
  border: 1px solid var(--border-color);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.order-client:hover {
  border-color: var(--accent-primary);
  box-shadow: var(--shadow-sm);
}

.client-info {
  display: flex;
  align-items: flex-start;
  gap: 1.25rem;
}

.client-avatar {
  flex-shrink: 0;
  width: 64px;
  height: 64px;
  border-radius: 50%;
  overflow: hidden;
  background: var(--nav-hover-bg);
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid var(--border-color);
}

.client-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.client-details {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.client-name {
  font-size: 1.25rem;
  font-weight: 600;
  color: var(--text-primary);
  margin: 0;
}

.client-contact {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.9375rem;
  color: var(--text-secondary);
}

.contact-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--accent-primary);
}

/* Additional Info Styles */
.order-additional-info {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.order-timeline,
.order-address,
.order-companies {
  margin-bottom: 0;
  padding: 0;
  background: transparent;
  border-radius: 0;
  border: none;
}

.order-companies {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.companies-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  flex-wrap: wrap;
}

.btn-show-companies {
  padding: 8px 16px;
  background: var(--accent-primary);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 0.875rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: var(--shadow-sm);
}

.btn-show-companies:hover {
  transform: translateY(-1px);
  box-shadow: var(--shadow-md);
  background: var(--accent-hover);
}

.btn-show-companies:active {
  transform: translateY(0);
}

.btn-show-companies:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

.companies-count-badge {
  padding: 0.75rem 1rem;
  background: var(--bg-primary);
  border: 1px solid var(--border-color);
  border-radius: 8px;
  font-size: 0.9375rem;
  color: var(--text-primary);
  font-weight: 500;
}

.companies-count {
  display: flex;
  align-items: center;
}

.count-value {
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--accent-primary);
  background: rgba(139, 92, 246, 0.1);
  padding: 8px 16px;
  border-radius: 8px;
  border: 1px solid var(--border-color);
}

/* Companies List Styles */
.companies-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 1rem;
  margin-top: 0.75rem;
}

.company-card {
  background: var(--bg-primary);
  border: 1px solid var(--border-color);
  border-radius: 12px;
  padding: 1rem;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.company-card:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-sm);
  border-color: var(--accent-primary);
}

.company-header {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.company-avatar {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid var(--border-color);
  flex-shrink: 0;
}

.company-avatar-placeholder {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: var(--accent-primary);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 1.5rem;
  font-weight: 700;
  flex-shrink: 0;
  border: 2px solid var(--border-color);
}

.company-info {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  min-width: 0;
}

.company-name {
  font-size: 1.125rem;
  font-weight: 600;
  color: var(--text-primary);
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.company-phone {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.875rem;
  color: var(--text-secondary);
}

.company-rating {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem;
  background: var(--bg-secondary);
  border-radius: 8px;
  border: 1px solid var(--border-color);
}

.rating-stars {
  font-size: 1rem;
  color: #f59e0b;
  letter-spacing: 0.1em;
}

.rating-value {
  font-size: 0.9375rem;
  font-weight: 600;
  color: var(--text-primary);
}

.empty-state {
  padding: 2rem;
  text-align: center;
  color: var(--text-secondary);
  background: var(--bg-secondary);
  border-radius: 8px;
  border: 1px dashed var(--border-color);
}

.empty-state p {
  margin: 0;
  font-size: 0.9375rem;
}

/* Section Headers - removed, using section-title instead */

/* Address Details */
.address-details {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.address-full {
  padding: 12px;
  background: var(--bg-secondary);
  border-radius: 8px;
  border-left: 3px solid #10b981;
  font-size: 0.9375rem;
  line-height: 1.6;
  color: var(--text-primary);
  border: 1px solid var(--border-color);
}

.address-breakdown {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 0.75rem;
  margin-top: 0.75rem;
}

.address-details p {
  margin: 0;
  padding: 0.5rem 0;
  background: transparent;
  border-radius: 0;
  border-left: none;
  border-bottom: 1px solid var(--border-color);
  font-size: 0.875rem;
  color: var(--text-primary);
}

.address-details strong {
  color: var(--text-secondary);
  font-weight: 600;
}

/* Category Details */
.category-details {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.category-details .info-item {
  margin: 0;
}

/* Tags Container */
.tags-container {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.tag {
  background: rgba(139, 92, 246, 0.1);
  color: var(--accent-color);
  padding: 0.375rem 0.75rem;
  border-radius: 6px;
  font-size: 0.8125rem;
  font-weight: 500;
  box-shadow: none;
  border: 1px solid var(--accent-color);
  transition: none;
}

.tag:hover {
  transform: none;
  box-shadow: none;
  background: rgba(139, 92, 246, 0.2);
}

/* Files Container */
.files-container {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
}

.file-link {
  display: inline-flex;
  align-items: center;
  padding: 0.5rem 0.75rem;
  background: transparent;
  color: var(--accent-color);
  text-decoration: none;
  border-radius: 4px;
  font-weight: 500;
  font-size: 0.875rem;
  transition: none;
  box-shadow: none;
  border: 1px solid var(--accent-color);
}

.file-link:hover {
  transform: none;
  box-shadow: none;
  text-decoration: underline;
  color: var(--accent-hover);
  background: var(--bg-secondary);
}

/* Loading and Error States */
.loading-state,
.error-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 400px;
  text-align: center;
  gap: 1.5rem;
}

/* Spinners removed globally */

.loading-state {
  color: var(--text-secondary);
  font-size: 1.125rem;
  font-weight: 500;
}

.error-state {
  color: #ef4444;
}

.error-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ef4444;
}

.error-state h2 {
  font-size: 1.5rem;
  margin: 0 0 1rem 0;
  color: #ef4444;
}

.error-state p {
  font-size: 1rem;
  color: var(--text-secondary);
  margin-bottom: 2rem;
}

/* Фикс для ID: убираем принудительную ширину 92px из других стилей */
.id-label-fixed {
  width: auto !important;
  min-width: 0 !important;
  max-width: fit-content !important;
  margin-right: 8px !important;
  flex: 0 0 auto !important;
  display: inline-block !important;
  white-space: nowrap !important;
}

.id-value-fixed {
  flex: 1 1 !important;
  min-width: 0 !important;
  word-break: break-all !important;
  overflow-wrap: break-word !important;
}

/* Animation for cards - removed */

/* Responsive Design */
@media (max-width: 768px) {
  .order-details-page {
    padding: 1rem;
    margin-top: 60px;
    min-height: calc(100vh - 60px);
  }

  .order-content-grid {
    grid-template-columns: 1fr;
  }

  .order-meta-grid {
    grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  }

  .order-card {
    padding: 1.25rem;
  }

  .order-column.narrow .order-card {
    position: static;
  }

  .info-grid,
  .timeline-grid,
  .stats-grid {
    grid-template-columns: 1fr;
    gap: 1rem;
  }
}

@media (max-width: 640px) {
  .order-details-page {
    padding: 0.5rem;
  }

  .order-number {
    font-size: 1.5rem;
  }

  .info-item,
  .timeline-item,
  .stat-item {
    padding: 0.625rem 0.75rem;
  }
}

/* Focus states for accessibility */
.back-link:focus,
.file-link:focus,
.tag:focus,
.info-item:focus,
.timeline-item:focus,
.stat-item:focus {
  outline: 2px solid #3b82f6;
  outline-offset: 2px;
}

/* Print Styles */
@media print {
  .order-details-page {
    background: var(--bg-secondary);
    margin-top: 0;
  }

  .back-link {
    display: none;
  }

  .order-main-info,
  .order-timeline,
  .order-address,
  .order-tags,
  .order-files,
  .order-stats,
  .order-category {
    box-shadow: none;
    border: 1px solid var(--border-color);
    page-break-inside: avoid;
    break-inside: avoid;
  }
}

/* Special styling for financial info - removed */
.order-main-info .info-item:nth-child(5),
.order-main-info .info-item:nth-child(6) {
  border-left: none;
  background: transparent;
}

.order-main-info .info-item:nth-child(5):hover,
.order-main-info .info-item:nth-child(6):hover {
  background: transparent;
}

/* Special styling for timeline - removed */
.order-timeline .timeline-item {
  border-left: none;
  background: transparent;
}

.order-timeline .timeline-item:hover {
  background: transparent;
}

/* Layout for sections */
.order-content-grid {
  display: grid;
  grid-template-columns: 1.6fr 0.9fr;
  gap: 1.25rem;
  align-items: start;
}

.order-column {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.order-card {
  background: var(--bg-secondary);
  border: 1px solid var(--border-color);
  border-radius: 16px;
  padding: 1.5rem;
  box-shadow: var(--shadow-sm);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.order-card:hover {
  box-shadow: var(--shadow-md);
  border-color: var(--accent-color);
}

.section-heading {
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
  margin-bottom: 1.25rem;
}

.section-chip {
  align-self: flex-start;
  background: rgba(139, 92, 246, 0.1);
  color: var(--accent-color);
  padding: 0.25rem 0.7rem;
  border-radius: 999px;
  font-weight: 700;
  font-size: 0.8rem;
  border: 1px solid var(--accent-color);
}

.section-subtitle {
  margin: 0;
  color: var(--text-secondary);
  font-size: 0.95rem;
}

.section-subtitle.compact {
  font-size: 0.85rem;
}

.order-subgrid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 1.25rem;
}

.card-block {
  padding: 1.25rem;
  background: var(--bg-primary);
  border: 1px solid var(--border-color);
  border-radius: 12px;
  box-shadow: var(--shadow-sm);
}

.order-column.narrow .order-card {
  position: static;
}

.customer-card {
  background: var(--bg-secondary);
  border: 1px solid var(--border-color);
}

.company-card {
  background: var(--bg-primary);
}

.clickable-card {
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.clickable-card:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-md);
  border-color: var(--accent-color);
}

.clickable-card:focus-visible {
  outline: 2px solid var(--accent-color);
  outline-offset: 3px;
}

.chips-row {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-top: 0.75rem;
}

.tag-chip {
  background: rgba(139, 92, 246, 0.1);
  color: var(--accent-color);
  border: 1px solid var(--accent-color);
  padding: 0.35rem 0.75rem;
  border-radius: 999px;
  font-weight: 600;
  font-size: 0.85rem;
  letter-spacing: 0.01em;
}

.company-meta {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.company-icon {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  background: rgba(139, 92, 246, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.25rem;
  color: var(--accent-color);
}

.company-name {
  font-weight: 700;
  color: var(--text-primary);
}

.company-id {
  color: var(--text-secondary);
  font-size: 0.9rem;
  font-family: 'SF Mono', 'Menlo', 'Monaco', Consolas, 'Courier New', monospace;
}

.order-timeline .timeline-item,
.order-address .address-full {
  background: var(--bg-secondary);
}

/* Status Management Styles */
.status-management {
  border-left: 4px solid #3b82f6;
}

.status-controls {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.current-status,
.status-actions {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1rem;
  background: var(--bg-primary);
  border-radius: 8px;
}

.status-label,
.actions-label {
  font-weight: 600;
  color: var(--text-primary);
  min-width: 120px;
}

.status-buttons {
  display: flex;
  gap: 0.75rem;
  flex-wrap: wrap;
}

.status-button {
  padding: 0.75rem 1.5rem;
  border: 2px solid var(--border-color);
  border-radius: 8px;
  background: var(--bg-secondary);
  color: var(--text-primary);
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
}

.status-button:hover:not(.disabled):not(.active) {
  background: var(--bg-primary);
  transform: translateY(-2px);
}

.status-button.active {
  background: #3b82f6;
  color: white;
  border-color: #3b82f6;
}

.status-button.disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.button-spinner {
  width: 16px;
  height: 16px;
  border: 2px solid transparent;
  border-top: 2px solid currentColor;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-left: 8px;
}

/* Status Badges */
.status-green {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  color: white;
}

.status-yellow {
  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
  color: white;
}

.status-red {
  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
  color: white;
}

/* Messages */
.message {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 1.5rem;
  border-radius: 8px;
  margin-bottom: 1.5rem;
  font-weight: 600;
}

.message.success {
  background: linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%);
  color: #065f46;
  border: 1px solid #10b981;
}

.message.error {
  background: linear-gradient(135deg, #fee2e2 0%, #fecaca 100%);
  color: #dc2626;
  border: 1px solid #ef4444;
}

.message-close {
  background: none;
  border: none;
  font-size: 1.25rem;
  cursor: pointer;
  color: inherit;
  padding: 0;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Responsive */
@media (max-width: 768px) {

  .current-status,
  .status-actions {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.75rem;
  }

  .status-buttons {
    width: 100%;
  }

  .status-button {
    flex: 1 1;
    min-width: 120px;
  }
}

/* Добавляем в order-details.css */

/* Стили для заголовка с контекстом жалобы */
.order-details-header {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 1rem;
}

.header-buttons {
  display: flex;
  align-items: center;
}

.complaint-context {
  display: flex;
  align-items: center;
}

.context-badge {
  background: #dbeafe;
  color: #1e40af;
  padding: 0.375rem 0.75rem;
  border-radius: 6px;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: none;
  letter-spacing: 0;
  box-shadow: none;
  border: 1px solid #93c5fd;
}

/* Стили для кнопки возврата к жалобе - обновлены выше */

/* Адаптивность для заголовка */
@media (max-width: 768px) {
  .order-details-header {
    flex-direction: column;
    align-items: flex-start;
  }

  .complaint-context {
    align-self: flex-end;
  }
}

/* Minimalist "no movement" override (remove кривые hover transforms) */
.order-details-page *:hover {
  transform: none !important;
}

.order-details-page *:focus {
  transform: none !important;
}`, "",{"version":3,"sources":["webpack://./src/css/order-details.css"],"names":[],"mappings":"AAAA,iDAAiD;AACjD;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,8BAA8B;EAC9B,6BAA6B;EAC7B,0BAA0B;EAC1B,8EAA8E;AAChF;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,4BAA4B;EAC5B,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,iDAAiD;EACjD,+BAA+B;EAC/B,4BAA4B;EAC5B,qCAAqC;EACrC,oBAAoB;AACtB;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;EAC1B,mCAAmC;AACrC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,SAAS;EACT,wBAAwB;AAC1B;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,+BAA+B;EAC/B,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;EACb,4BAA4B;EAC5B,iDAAiD;AACnD;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,4BAA4B;EAC5B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,SAAS;EACT,yDAAyD;AAC3D;;AAEA;EACE,SAAS;EACT,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,6BAA6B;EAC7B,qCAAqC;EACrC,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iDAAiD;AACnD;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;EAC1B,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,6BAA6B;EAC7B,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;EACb,iDAAiD;AACnD;;AAEA;EACE,mCAAmC;EACnC,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,4BAA4B;EAC5B,oBAAoB;EACpB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;AAClB;;AAEA,+CAA+C;AAC/C;;;;;;EAME,uBAAuB;EACvB,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,6BAA6B;EAC7B,qCAAqC;EACrC,mBAAmB;EACnB,gBAAgB;EAChB,4BAA4B;EAC5B,iDAAiD;EACjD,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,qCAAqC;EACrC,+BAA+B;AACjC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,SAAS;EACT,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,iBAAiB;EACjB,0BAA0B;EAC1B,qBAAqB;EACrB,uBAAuB;EACvB,4CAA4C;EAC5C,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA,kDAAkD;;AAElD;EACE,uBAAuB;EACvB,YAAY;EACZ,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,YAAY;EACZ,6BAA6B;EAC7B,qCAAqC;EACrC,mBAAmB;EACnB,4BAA4B;EAC5B,uBAAuB;EACvB,WAAW;EACX,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,4BAA4B;EAC5B,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,qCAAqC;EACrC,mBAAmB;EACnB,+BAA+B;EAC/B,0BAA0B;EAC1B,gBAAgB;EAChB,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,iCAAiC;EACjC,WAAW;EACX,6BAA6B;EAC7B,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,qCAAqC;EACrC,uBAAuB;EACvB,0BAA0B;EAC1B,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;;EAEA;IACE,UAAU;IACV,oCAAoC;EACtC;;EAEA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;EAC7B,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA,eAAe;AACf;;;EAGE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;;;EAGE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,aAAa;EACb,6BAA6B;EAC7B,kBAAkB;EAClB,0CAA0C;EAC1C,qCAAqC;EACrC,iDAAiD;AACnD;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;;EAGE,+BAA+B;EAC/B,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;;;EAGE,oBAAoB;EACpB,gBAAgB;EAChB,4BAA4B;EAC5B,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;;EAGE,oBAAoB;EACpB,0BAA0B;EAC1B,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,uBAAuB;AACvB;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,eAAe;EACf,qCAAqC;EACrC,iDAAiD;AACnD;;AAEA;EACE,mCAAmC;EACnC,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;;;EAGE,gBAAgB;EAChB,UAAU;EACV,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,iCAAiC;EACjC,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iDAAiD;EACjD,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,6BAA6B;EAC7B,qCAAqC;EACrC,kBAAkB;EAClB,oBAAoB;EACpB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,4BAA4B;EAC5B,mCAAmC;EACnC,iBAAiB;EACjB,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;EACb,iDAAiD;EACjD,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,0BAA0B;EAC1B,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,+BAA+B;EAC/B,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,4BAA4B;EAC5B,+BAA+B;EAC/B,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,SAAS;EACT,oBAAoB;AACtB;;AAEA,2DAA2D;;AAE3D,oBAAoB;AACpB;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,kBAAkB;EAClB,8BAA8B;EAC9B,oBAAoB;EACpB,gBAAgB;EAChB,0BAA0B;EAC1B,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,4CAA4C;EAC5C,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,SAAS;AACX;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,mCAAmC;EACnC,0BAA0B;EAC1B,yBAAyB;EACzB,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,eAAe;EACf,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,0BAA0B;EAC1B,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,0BAA0B;EAC1B,+BAA+B;AACjC;;AAEA,6BAA6B;AAC7B;;EAEE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;AACb;;AAEA,8BAA8B;;AAE9B;EACE,4BAA4B;EAC5B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA,qEAAqE;AACrE;EACE,sBAAsB;EACtB,uBAAuB;EACvB,iCAAiC;EACjC,4BAA4B;EAC5B,yBAAyB;EACzB,gCAAgC;EAChC,8BAA8B;AAChC;;AAEA;EACE,oBAAkB;EAClB,uBAAuB;EACvB,gCAAgC;EAChC,oCAAoC;AACtC;;AAEA,kCAAkC;;AAElC,sBAAsB;AACtB;EACE;IACE,aAAa;IACb,gBAAgB;IAChB,8BAA8B;EAChC;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,2DAA2D;EAC7D;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;;IAGE,0BAA0B;IAC1B,SAAS;EACX;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;;IAGE,yBAAyB;EAC3B;AACF;;AAEA,mCAAmC;AACnC;;;;;;EAME,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE;IACE,+BAA+B;IAC/B,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;;;;;;;IAOE,gBAAgB;IAChB,qCAAqC;IACrC,wBAAmB;IAAnB,mBAAmB;EACrB;AACF;;AAEA,iDAAiD;AACjD;;EAEE,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA,2CAA2C;AAC3C;EACE,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,kCAAkC;EAClC,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,+BAA+B;EAC/B,qCAAqC;EACrC,mBAAmB;EACnB,eAAe;EACf,4BAA4B;EAC5B,iDAAiD;AACnD;;AAEA;EACE,4BAA4B;EAC5B,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,mCAAmC;EACnC,0BAA0B;EAC1B,uBAAuB;EACvB,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;EACjB,qCAAqC;AACvC;;AAEA;EACE,SAAS;EACT,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,qCAAqC;EACrC,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,qCAAqC;AACvC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,iDAAiD;AACnD;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,iCAAiC;AACnC;;AAEA;EACE,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,0BAA0B;EAC1B,qCAAqC;EACrC,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mCAAmC;EACnC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;EAC5B,iBAAiB;EACjB,6EAA6E;AAC/E;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA,6BAA6B;AAC7B;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;;EAEE,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,qCAAqC;EACrC,kBAAkB;EAClB,+BAA+B;EAC/B,0BAA0B;EAC1B,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,kCAAkC;EAClC,kBAAkB;EAClB,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,6DAA6D;EAC7D,YAAY;AACd;;AAEA;EACE,6DAA6D;EAC7D,YAAY;AACd;;AAEA;EACE,6DAA6D;EAC7D,YAAY;AACd;;AAEA,aAAa;AACb;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;EAC7D,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,6DAA6D;EAC7D,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,eAAe;AACf;;EAEE;;IAEE,sBAAsB;IACtB,uBAAuB;IACvB,YAAY;EACd;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,SAAO;IACP,gBAAgB;EAClB;AACF;;AAEA,kCAAkC;;AAElC,4CAA4C;AAC5C;EACE,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA,wDAAwD;;AAExD,+BAA+B;AAC/B;EACE;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,oBAAoB;EACtB;AACF;;AAEA,uEAAuE;AACvE;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B","sourcesContent":["/* Order Details Page Styles - Minimalist Theme */\n.order-details-page {\n  padding: 1.5rem;\n  max-width: 1200px;\n  margin: 0 auto;\n  min-height: calc(100vh - 80px);\n  background: var(--bg-primary);\n  color: var(--text-primary);\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n}\n\n.order-details-header {\n  margin-bottom: 2rem;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 1rem;\n}\n\n.back-link {\n  display: inline-flex;\n  align-items: center;\n  color: var(--text-secondary);\n  text-decoration: none;\n  font-weight: 500;\n  margin-bottom: 1rem;\n  padding: 8px 16px;\n  border-radius: 8px;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  background: var(--bg-secondary);\n  box-shadow: var(--shadow-sm);\n  border: 1px solid var(--border-color);\n  font-size: 0.9375rem;\n}\n\n.back-link:hover {\n  background: var(--nav-hover-bg);\n  color: var(--text-primary);\n  border-color: var(--accent-primary);\n}\n\n.order-details-title {\n  font-size: 2rem;\n  font-weight: 700;\n  color: var(--text-primary);\n  margin: 0;\n  letter-spacing: -0.015em;\n}\n\n/* Order Details Container */\n.order-details-container {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n}\n\n.order-hero-card {\n  background: var(--bg-secondary);\n  border: 1px solid var(--border-color);\n  border-radius: 16px;\n  padding: 2rem;\n  box-shadow: var(--shadow-md);\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.order-hero-card:hover {\n  border-color: var(--accent-primary);\n}\n\n.order-hero-top {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 1rem;\n  flex-wrap: wrap;\n}\n\n.order-id-block {\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n}\n\n.eyebrow {\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  font-size: 0.75rem;\n  color: var(--text-secondary);\n  margin: 0;\n  font-weight: 700;\n}\n\n.order-number {\n  font-size: 1.75rem;\n  color: var(--text-primary);\n  margin: 0;\n  font-family: 'SF Mono', 'Courier New', Courier, monospace;\n}\n\n.order-id-hint {\n  margin: 0;\n  color: var(--text-secondary);\n  font-size: 0.875rem;\n}\n\n.order-status-block {\n  display: flex;\n  align-items: flex-end;\n  gap: 0.5rem;\n  position: relative;\n}\n\n.status-badge-wrapper {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.status-edit-btn {\n  background: var(--bg-primary);\n  border: 1px solid var(--border-color);\n  border-radius: 8px;\n  padding: 8px;\n  cursor: pointer;\n  color: var(--text-secondary);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.status-edit-btn:hover {\n  background: var(--nav-hover-bg);\n  color: var(--text-primary);\n  border-color: var(--accent-primary);\n  transform: translateY(-1px);\n}\n\n.order-meta-grid {\n  margin-top: 1.5rem;\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));\n  gap: 1rem;\n}\n\n.meta-card {\n  background: var(--bg-primary);\n  border: 1px solid var(--border-color);\n  border-radius: 12px;\n  padding: 1rem;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.meta-card:hover {\n  border-color: var(--accent-primary);\n  box-shadow: var(--shadow-sm);\n  transform: translateY(-2px);\n}\n\n.meta-label {\n  display: block;\n  color: var(--text-secondary);\n  font-size: 0.8125rem;\n  font-weight: 600;\n  margin-bottom: 0.5rem;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.meta-value {\n  color: var(--text-primary);\n  font-size: 1rem;\n  font-weight: 700;\n}\n\n/* Card Styles - убраны блоки, обычный формат */\n.order-main-info,\n.order-client,\n.order-additional-info,\n.order-timeline,\n.order-address,\n.order-companies {\n  background: transparent;\n  border-radius: 0;\n  padding: 0;\n  box-shadow: none;\n  border: none;\n  margin-bottom: 2rem;\n}\n\n.photo-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));\n  gap: 0.85rem;\n}\n\n.photo-thumb {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  background: var(--bg-primary);\n  border: 1px solid var(--border-color);\n  border-radius: 12px;\n  padding: 0.75rem;\n  box-shadow: var(--shadow-sm);\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  text-decoration: none;\n  color: var(--text-primary);\n}\n\n.photo-thumb:hover {\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-md);\n  border-color: var(--accent-primary);\n}\n\n.photo-thumb img {\n  width: 100%;\n  height: 160px;\n  object-fit: cover;\n  border-radius: 8px;\n  border: 1px solid var(--border-color);\n  background: var(--nav-hover-bg);\n}\n\n.photo-name {\n  font-size: 0.9rem;\n  font-weight: 600;\n  color: var(--text-primary);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.order-photos {\n  margin-bottom: 2rem;\n}\n\n/* Order ID Section */\n.order-id-section {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 2rem;\n  padding-bottom: 1rem;\n  border-bottom: 2px solid var(--border-color);\n}\n\n.order-id-section h2 {\n  font-size: 1.75rem;\n  color: var(--text-primary);\n  margin: 0;\n  font-weight: 700;\n}\n\n/* Section Titles */\n.section-title {\n  font-size: 1.5rem;\n  color: var(--text-primary);\n  margin: 0 0 1.25rem 0;\n  padding-bottom: 0.75rem;\n  border-bottom: 2px solid var(--border-color);\n  font-weight: 700;\n  letter-spacing: -0.015em;\n}\n\n.order-photos .section-title {\n  margin-bottom: 0.5rem;\n}\n\n.order-photos .section-subtitle {\n  margin-top: -0.35rem;\n  margin-bottom: 0.85rem;\n}\n\n.subsection-title {\n  font-size: 1.125rem;\n  color: var(--text-primary);\n  margin: 0 0 0.75rem 0;\n  font-weight: 600;\n}\n\n/* Status badge styles moved to status-badge.css */\n\n.status-badge-button {\n  background: transparent;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n}\n\n.status-popup {\n  position: absolute;\n  top: 112%;\n  right: 0;\n  width: 250px;\n  background: var(--bg-primary);\n  border: 1px solid var(--border-color);\n  border-radius: 12px;\n  box-shadow: var(--shadow-sm);\n  padding: 12px 12px 10px;\n  z-index: 50;\n  transform-origin: top right;\n  animation: statusPopupPop 0.2s ease-out both;\n}\n\n.status-popup-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  font-weight: 800;\n  color: var(--text-primary);\n  margin-bottom: 10px;\n}\n\n.status-popup-close {\n  background: transparent;\n  border: none;\n  font-size: 1.15rem;\n  line-height: 1;\n  cursor: pointer;\n  color: var(--text-secondary);\n  transition: color 0.2s ease;\n  width: 28px;\n  height: 28px;\n  border-radius: 8px;\n}\n\n.status-popup-close:hover {\n  color: var(--text-primary);\n  background: var(--nav-hover-bg);\n}\n\n.status-popup-body select {\n  width: 100%;\n  padding: 10px 12px;\n  border: 1px solid var(--border-color);\n  border-radius: 10px;\n  background: var(--bg-secondary);\n  color: var(--text-primary);\n  font-weight: 600;\n  outline: none;\n  transition: border-color 0.2s ease;\n}\n\n.status-popup-body select:focus {\n  border-color: var(--accent-primary);\n}\n\n.status-popup-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  margin-top: 12px;\n}\n\n.status-popup .btn.btn-primary {\n  padding: 10px 14px;\n  border-radius: 10px;\n  background: var(--accent-primary);\n  color: #fff;\n  border: 1px solid transparent;\n  font-weight: 700;\n  transition: all 0.2s ease;\n}\n\n.status-popup .btn.btn-primary:not(:disabled):hover {\n  background: var(--accent-hover);\n}\n\n.status-popup .btn.btn-secondary {\n  padding: 10px 14px;\n  border-radius: 10px;\n  border: 1px solid var(--border-color);\n  background: transparent;\n  color: var(--text-primary);\n  font-weight: 700;\n  transition: all 0.2s ease;\n}\n\n.status-popup .btn.btn-secondary:hover {\n  background: var(--nav-hover-bg);\n}\n\n@keyframes statusPopupPop {\n  from {\n    opacity: 0;\n    transform: translateY(-6px) scale(0.98);\n  }\n\n  60% {\n    opacity: 1;\n    transform: translateY(0) scale(1.02);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n.status-badge.pending {\n  background: #fef3c7;\n  color: #92400e;\n  border-color: #fcd34d;\n}\n\n.status-badge.in-progress {\n  background: #dbeafe;\n  color: #1e40af;\n  border-color: #93c5fd;\n}\n\n.status-badge.in-work {\n  background: #fef3c7;\n  color: #92400e;\n  border-color: #fcd34d;\n}\n\n.status-badge.done {\n  background: #d1fae5;\n  color: #065f46;\n  border-color: #6ee7b7;\n}\n\n.status-badge.canceled {\n  background: #fee2e2;\n  color: #991b1b;\n  border-color: #fca5a5;\n}\n\n.status-badge.completed {\n  background: #d1fae5;\n  color: #065f46;\n  border-color: #6ee7b7;\n}\n\n.status-badge.cancelled {\n  background: #fee2e2;\n  color: #991b1b;\n  border-color: #fca5a5;\n}\n\n.status-badge.unknown {\n  background: var(--bg-primary);\n  color: var(--text-primary);\n  border-color: #d1d5db;\n}\n\n/* Info Grids */\n.info-grid,\n.timeline-grid,\n.stats-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 1rem;\n}\n\n.info-item,\n.timeline-item,\n.stat-item {\n  display: flex;\n  flex-direction: row;\n  align-items: baseline;\n  padding: 12px;\n  background: var(--bg-primary);\n  border-radius: 8px;\n  border-left: 3px solid var(--accent-color);\n  border: 1px solid var(--border-color);\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.timeline-item {\n  border-left-color: #8b5cf6;\n}\n\n.info-item:hover,\n.timeline-item:hover,\n.stat-item:hover {\n  background: var(--nav-hover-bg);\n  border-color: var(--accent-primary);\n  transform: translateY(-1px);\n}\n\n.info-item label,\n.timeline-item label,\n.stat-item label {\n  font-size: 0.8125rem;\n  font-weight: 600;\n  color: var(--text-secondary);\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  margin-bottom: 0;\n  margin-right: 0.75rem;\n  min-width: 140px;\n  flex-shrink: 0;\n}\n\n.info-item span,\n.timeline-item span,\n.stat-item span {\n  font-size: 0.9375rem;\n  color: var(--text-primary);\n  font-weight: 500;\n  word-break: break-word;\n  line-height: 1.5;\n  flex: 1;\n}\n\n.price-value {\n  font-size: 1.125rem;\n  font-weight: 600;\n  color: #10b981;\n}\n\n/* Client Info Styles */\n.order-client {\n  background: var(--bg-primary);\n  border-radius: 16px;\n  padding: 1.5rem;\n  border: 1px solid var(--border-color);\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.order-client:hover {\n  border-color: var(--accent-primary);\n  box-shadow: var(--shadow-sm);\n}\n\n.client-info {\n  display: flex;\n  align-items: flex-start;\n  gap: 1.25rem;\n}\n\n.client-avatar {\n  flex-shrink: 0;\n  width: 64px;\n  height: 64px;\n  border-radius: 50%;\n  overflow: hidden;\n  background: var(--nav-hover-bg);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 2px solid var(--border-color);\n}\n\n.client-avatar img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.client-details {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.client-name {\n  font-size: 1.25rem;\n  font-weight: 600;\n  color: var(--text-primary);\n  margin: 0;\n}\n\n.client-contact {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-size: 0.9375rem;\n  color: var(--text-secondary);\n}\n\n.contact-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--accent-primary);\n}\n\n/* Additional Info Styles */\n.order-additional-info {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n}\n\n.order-timeline,\n.order-address,\n.order-companies {\n  margin-bottom: 0;\n  padding: 0;\n  background: transparent;\n  border-radius: 0;\n  border: none;\n}\n\n.order-companies {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.companies-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n  flex-wrap: wrap;\n}\n\n.btn-show-companies {\n  padding: 8px 16px;\n  background: var(--accent-primary);\n  color: white;\n  border: none;\n  border-radius: 8px;\n  font-size: 0.875rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  box-shadow: var(--shadow-sm);\n}\n\n.btn-show-companies:hover {\n  transform: translateY(-1px);\n  box-shadow: var(--shadow-md);\n  background: var(--accent-hover);\n}\n\n.btn-show-companies:active {\n  transform: translateY(0);\n}\n\n.btn-show-companies:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.companies-count-badge {\n  padding: 0.75rem 1rem;\n  background: var(--bg-primary);\n  border: 1px solid var(--border-color);\n  border-radius: 8px;\n  font-size: 0.9375rem;\n  color: var(--text-primary);\n  font-weight: 500;\n}\n\n.companies-count {\n  display: flex;\n  align-items: center;\n}\n\n.count-value {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: var(--accent-primary);\n  background: rgba(139, 92, 246, 0.1);\n  padding: 8px 16px;\n  border-radius: 8px;\n  border: 1px solid var(--border-color);\n}\n\n/* Companies List Styles */\n.companies-list {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\n  gap: 1rem;\n  margin-top: 0.75rem;\n}\n\n.company-card {\n  background: var(--bg-primary);\n  border: 1px solid var(--border-color);\n  border-radius: 12px;\n  padding: 1rem;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.company-card:hover {\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-sm);\n  border-color: var(--accent-primary);\n}\n\n.company-header {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.company-avatar {\n  width: 56px;\n  height: 56px;\n  border-radius: 50%;\n  object-fit: cover;\n  border: 2px solid var(--border-color);\n  flex-shrink: 0;\n}\n\n.company-avatar-placeholder {\n  width: 56px;\n  height: 56px;\n  border-radius: 50%;\n  background: var(--accent-primary);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  font-size: 1.5rem;\n  font-weight: 700;\n  flex-shrink: 0;\n  border: 2px solid var(--border-color);\n}\n\n.company-info {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  min-width: 0;\n}\n\n.company-name {\n  font-size: 1.125rem;\n  font-weight: 600;\n  color: var(--text-primary);\n  margin: 0;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.company-phone {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-size: 0.875rem;\n  color: var(--text-secondary);\n}\n\n.company-rating {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.5rem;\n  background: var(--bg-secondary);\n  border-radius: 8px;\n  border: 1px solid var(--border-color);\n}\n\n.rating-stars {\n  font-size: 1rem;\n  color: #f59e0b;\n  letter-spacing: 0.1em;\n}\n\n.rating-value {\n  font-size: 0.9375rem;\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.empty-state {\n  padding: 2rem;\n  text-align: center;\n  color: var(--text-secondary);\n  background: var(--bg-secondary);\n  border-radius: 8px;\n  border: 1px dashed var(--border-color);\n}\n\n.empty-state p {\n  margin: 0;\n  font-size: 0.9375rem;\n}\n\n/* Section Headers - removed, using section-title instead */\n\n/* Address Details */\n.address-details {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.address-full {\n  padding: 12px;\n  background: var(--bg-secondary);\n  border-radius: 8px;\n  border-left: 3px solid #10b981;\n  font-size: 0.9375rem;\n  line-height: 1.6;\n  color: var(--text-primary);\n  border: 1px solid var(--border-color);\n}\n\n.address-breakdown {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 0.75rem;\n  margin-top: 0.75rem;\n}\n\n.address-details p {\n  margin: 0;\n  padding: 0.5rem 0;\n  background: transparent;\n  border-radius: 0;\n  border-left: none;\n  border-bottom: 1px solid var(--border-color);\n  font-size: 0.875rem;\n  color: var(--text-primary);\n}\n\n.address-details strong {\n  color: var(--text-secondary);\n  font-weight: 600;\n}\n\n/* Category Details */\n.category-details {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.category-details .info-item {\n  margin: 0;\n}\n\n/* Tags Container */\n.tags-container {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n}\n\n.tag {\n  background: rgba(139, 92, 246, 0.1);\n  color: var(--accent-color);\n  padding: 0.375rem 0.75rem;\n  border-radius: 6px;\n  font-size: 0.8125rem;\n  font-weight: 500;\n  box-shadow: none;\n  border: 1px solid var(--accent-color);\n  transition: none;\n}\n\n.tag:hover {\n  transform: none;\n  box-shadow: none;\n  background: rgba(139, 92, 246, 0.2);\n}\n\n/* Files Container */\n.files-container {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.75rem;\n}\n\n.file-link {\n  display: inline-flex;\n  align-items: center;\n  padding: 0.5rem 0.75rem;\n  background: transparent;\n  color: var(--accent-color);\n  text-decoration: none;\n  border-radius: 4px;\n  font-weight: 500;\n  font-size: 0.875rem;\n  transition: none;\n  box-shadow: none;\n  border: 1px solid var(--accent-color);\n}\n\n.file-link:hover {\n  transform: none;\n  box-shadow: none;\n  text-decoration: underline;\n  color: var(--accent-hover);\n  background: var(--bg-secondary);\n}\n\n/* Loading and Error States */\n.loading-state,\n.error-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 400px;\n  text-align: center;\n  gap: 1.5rem;\n}\n\n/* Spinners removed globally */\n\n.loading-state {\n  color: var(--text-secondary);\n  font-size: 1.125rem;\n  font-weight: 500;\n}\n\n.error-state {\n  color: #ef4444;\n}\n\n.error-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #ef4444;\n}\n\n.error-state h2 {\n  font-size: 1.5rem;\n  margin: 0 0 1rem 0;\n  color: #ef4444;\n}\n\n.error-state p {\n  font-size: 1rem;\n  color: var(--text-secondary);\n  margin-bottom: 2rem;\n}\n\n/* Фикс для ID: убираем принудительную ширину 92px из других стилей */\n.id-label-fixed {\n  width: auto !important;\n  min-width: 0 !important;\n  max-width: fit-content !important;\n  margin-right: 8px !important;\n  flex: 0 0 auto !important;\n  display: inline-block !important;\n  white-space: nowrap !important;\n}\n\n.id-value-fixed {\n  flex: 1 !important;\n  min-width: 0 !important;\n  word-break: break-all !important;\n  overflow-wrap: break-word !important;\n}\n\n/* Animation for cards - removed */\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .order-details-page {\n    padding: 1rem;\n    margin-top: 60px;\n    min-height: calc(100vh - 60px);\n  }\n\n  .order-content-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .order-meta-grid {\n    grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));\n  }\n\n  .order-card {\n    padding: 1.25rem;\n  }\n\n  .order-column.narrow .order-card {\n    position: static;\n  }\n\n  .info-grid,\n  .timeline-grid,\n  .stats-grid {\n    grid-template-columns: 1fr;\n    gap: 1rem;\n  }\n}\n\n@media (max-width: 640px) {\n  .order-details-page {\n    padding: 0.5rem;\n  }\n\n  .order-number {\n    font-size: 1.5rem;\n  }\n\n  .info-item,\n  .timeline-item,\n  .stat-item {\n    padding: 0.625rem 0.75rem;\n  }\n}\n\n/* Focus states for accessibility */\n.back-link:focus,\n.file-link:focus,\n.tag:focus,\n.info-item:focus,\n.timeline-item:focus,\n.stat-item:focus {\n  outline: 2px solid #3b82f6;\n  outline-offset: 2px;\n}\n\n/* Print Styles */\n@media print {\n  .order-details-page {\n    background: var(--bg-secondary);\n    margin-top: 0;\n  }\n\n  .back-link {\n    display: none;\n  }\n\n  .order-main-info,\n  .order-timeline,\n  .order-address,\n  .order-tags,\n  .order-files,\n  .order-stats,\n  .order-category {\n    box-shadow: none;\n    border: 1px solid var(--border-color);\n    break-inside: avoid;\n  }\n}\n\n/* Special styling for financial info - removed */\n.order-main-info .info-item:nth-child(5),\n.order-main-info .info-item:nth-child(6) {\n  border-left: none;\n  background: transparent;\n}\n\n.order-main-info .info-item:nth-child(5):hover,\n.order-main-info .info-item:nth-child(6):hover {\n  background: transparent;\n}\n\n/* Special styling for timeline - removed */\n.order-timeline .timeline-item {\n  border-left: none;\n  background: transparent;\n}\n\n.order-timeline .timeline-item:hover {\n  background: transparent;\n}\n\n/* Layout for sections */\n.order-content-grid {\n  display: grid;\n  grid-template-columns: 1.6fr 0.9fr;\n  gap: 1.25rem;\n  align-items: start;\n}\n\n.order-column {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n}\n\n.order-card {\n  background: var(--bg-secondary);\n  border: 1px solid var(--border-color);\n  border-radius: 16px;\n  padding: 1.5rem;\n  box-shadow: var(--shadow-sm);\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.order-card:hover {\n  box-shadow: var(--shadow-md);\n  border-color: var(--accent-color);\n}\n\n.section-heading {\n  display: flex;\n  flex-direction: column;\n  gap: 0.3rem;\n  margin-bottom: 1.25rem;\n}\n\n.section-chip {\n  align-self: flex-start;\n  background: rgba(139, 92, 246, 0.1);\n  color: var(--accent-color);\n  padding: 0.25rem 0.7rem;\n  border-radius: 999px;\n  font-weight: 700;\n  font-size: 0.8rem;\n  border: 1px solid var(--accent-color);\n}\n\n.section-subtitle {\n  margin: 0;\n  color: var(--text-secondary);\n  font-size: 0.95rem;\n}\n\n.section-subtitle.compact {\n  font-size: 0.85rem;\n}\n\n.order-subgrid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));\n  gap: 1.25rem;\n}\n\n.card-block {\n  padding: 1.25rem;\n  background: var(--bg-primary);\n  border: 1px solid var(--border-color);\n  border-radius: 12px;\n  box-shadow: var(--shadow-sm);\n}\n\n.order-column.narrow .order-card {\n  position: static;\n}\n\n.customer-card {\n  background: var(--bg-secondary);\n  border: 1px solid var(--border-color);\n}\n\n.company-card {\n  background: var(--bg-primary);\n}\n\n.clickable-card {\n  cursor: pointer;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.clickable-card:hover {\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-md);\n  border-color: var(--accent-color);\n}\n\n.clickable-card:focus-visible {\n  outline: 2px solid var(--accent-color);\n  outline-offset: 3px;\n}\n\n.chips-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n  margin-top: 0.75rem;\n}\n\n.tag-chip {\n  background: rgba(139, 92, 246, 0.1);\n  color: var(--accent-color);\n  border: 1px solid var(--accent-color);\n  padding: 0.35rem 0.75rem;\n  border-radius: 999px;\n  font-weight: 600;\n  font-size: 0.85rem;\n  letter-spacing: 0.01em;\n}\n\n.company-meta {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.company-icon {\n  width: 48px;\n  height: 48px;\n  border-radius: 12px;\n  background: rgba(139, 92, 246, 0.1);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.25rem;\n  color: var(--accent-color);\n}\n\n.company-name {\n  font-weight: 700;\n  color: var(--text-primary);\n}\n\n.company-id {\n  color: var(--text-secondary);\n  font-size: 0.9rem;\n  font-family: 'SF Mono', 'Menlo', 'Monaco', Consolas, 'Courier New', monospace;\n}\n\n.order-timeline .timeline-item,\n.order-address .address-full {\n  background: var(--bg-secondary);\n}\n\n/* Status Management Styles */\n.status-management {\n  border-left: 4px solid #3b82f6;\n}\n\n.status-controls {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n}\n\n.current-status,\n.status-actions {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  padding: 1rem;\n  background: var(--bg-primary);\n  border-radius: 8px;\n}\n\n.status-label,\n.actions-label {\n  font-weight: 600;\n  color: var(--text-primary);\n  min-width: 120px;\n}\n\n.status-buttons {\n  display: flex;\n  gap: 0.75rem;\n  flex-wrap: wrap;\n}\n\n.status-button {\n  padding: 0.75rem 1.5rem;\n  border: 2px solid var(--border-color);\n  border-radius: 8px;\n  background: var(--bg-secondary);\n  color: var(--text-primary);\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  position: relative;\n}\n\n.status-button:hover:not(.disabled):not(.active) {\n  background: var(--bg-primary);\n  transform: translateY(-2px);\n}\n\n.status-button.active {\n  background: #3b82f6;\n  color: white;\n  border-color: #3b82f6;\n}\n\n.status-button.disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.button-spinner {\n  width: 16px;\n  height: 16px;\n  border: 2px solid transparent;\n  border-top: 2px solid currentColor;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin-left: 8px;\n}\n\n/* Status Badges */\n.status-green {\n  background: linear-gradient(135deg, #10b981 0%, #059669 100%);\n  color: white;\n}\n\n.status-yellow {\n  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);\n  color: white;\n}\n\n.status-red {\n  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);\n  color: white;\n}\n\n/* Messages */\n.message {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1rem 1.5rem;\n  border-radius: 8px;\n  margin-bottom: 1.5rem;\n  font-weight: 600;\n}\n\n.message.success {\n  background: linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%);\n  color: #065f46;\n  border: 1px solid #10b981;\n}\n\n.message.error {\n  background: linear-gradient(135deg, #fee2e2 0%, #fecaca 100%);\n  color: #dc2626;\n  border: 1px solid #ef4444;\n}\n\n.message-close {\n  background: none;\n  border: none;\n  font-size: 1.25rem;\n  cursor: pointer;\n  color: inherit;\n  padding: 0;\n  width: 24px;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n\n  .current-status,\n  .status-actions {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 0.75rem;\n  }\n\n  .status-buttons {\n    width: 100%;\n  }\n\n  .status-button {\n    flex: 1;\n    min-width: 120px;\n  }\n}\n\n/* Добавляем в order-details.css */\n\n/* Стили для заголовка с контекстом жалобы */\n.order-details-header {\n  position: relative;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 1rem;\n}\n\n.header-buttons {\n  display: flex;\n  align-items: center;\n}\n\n.complaint-context {\n  display: flex;\n  align-items: center;\n}\n\n.context-badge {\n  background: #dbeafe;\n  color: #1e40af;\n  padding: 0.375rem 0.75rem;\n  border-radius: 6px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  text-transform: none;\n  letter-spacing: 0;\n  box-shadow: none;\n  border: 1px solid #93c5fd;\n}\n\n/* Стили для кнопки возврата к жалобе - обновлены выше */\n\n/* Адаптивность для заголовка */\n@media (max-width: 768px) {\n  .order-details-header {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .complaint-context {\n    align-self: flex-end;\n  }\n}\n\n/* Minimalist \"no movement\" override (remove кривые hover transforms) */\n.order-details-page *:hover {\n  transform: none !important;\n}\n\n.order-details-page *:focus {\n  transform: none !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
